import { render, staticRenderFns } from "./akamai.vue?vue&type=template&id=49508108&"
import script from "./akamai.vue?vue&type=script&lang=js&"
export * from "./akamai.vue?vue&type=script&lang=js&"
import style0 from "./akamai.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports